<div class="slider-field">
  @if (props.label) {
  <label class="slider-label" [for]="id">{{ props.label }}</label>
  }
  <div class="slider-wrapper flex flex-align-center gap-md">
    <input type="range" class="slider-input" [id]="id" [min]="min" [max]="max" [step]="step" [value]="currentValue"
      [disabled]="formControl.disabled" (input)="onInput($event)" [attr.aria-label]="props.label"
      data-testid="slider-input" />
    <span class="slider-value" data-testid="slider-value">{{ displayValue }}</span>
  </div>
</div>